import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import util from '@/common/util'
// import TabsStore from '../components/tabs/store'

Vue.use(Vuex)
axios.defaults.timeout = 60000 // 请求的超时时间
axios.defaults.withCredentials = true // 允许携带cookie
export default new Vuex.Store({
  // modules: {
  //   TabsStore
  // },
  state: {
    // 分页的数据
    pagination: {
      pageIndex: 1, // 当前页
      pageSize: 10, // 每页数据条数
      total: 0, // 总条数
      pageSizes: [10, 20, 50, 100, 200]
    },
    ifDecOpen: false,
    appCount: 0, // 联系人未读数量
    paramVersion: '',
    sysId: 'officialsite',
    // 登陆后的用户数据信息
    userLoginInfo: {
      userId: '',
      token: '', // token数据
      userName: '', // 用户姓名
      companyType: '', // 公司类型
      isAdmin: '',
      companyCode: '', // 公司id
      mobile: '', // 手机号
      userPhoto: '', // 用户头像
      companyName: '',
      sccCode: '',
      adminFlag: '',
      cusCorpName: '', // 企业海关名
      ciqCode: '', // 企业检验检疫代码
      tradeCode: '' // 企业十位海关代码
    },
    childSys: {
      type: '',
      title: '',
      permissions: ''
    }, // 子级系统
    isFirst: true, // 是否初次进入系统
    loading: false, // loading
    collapse: false, // 菜单折叠
    menuShow: true, // 移动式菜单
    labelWidth: '100px', // form 表单 label 宽度
    tableHeight: '800', // table表格高度
    controlPanelList: [], // 已勾选看板
    sysType: util.checkSys(), // 登录平台
    netWork: '', // 是否断网
    servicePaths: [],
    userVipType: '', // 用户类型 visiter 游客 free 免费会员
    serviceTip: {
      tipsVisible: false,
      tipsTxt: ''
    }, // 是否展示服务提示框
    menuName: '' // 更改header菜单名
  },
  mutations: {
    // 设置子系统
    setChildSys: function (state, data) {
      state.childSys = data
      // TabsStore.mutations.SetChildSysData(TabsStore.state, data.type)
    },
    // 设置token
    setToken: function (state, token) {
      state.userLoginInfo.token = token
    },
    // 用户登录信息变更
    userLoginInfo: function (state, data) {
      state.userLoginInfo.userName = data.userName
      state.userLoginInfo.companyType = data.companyType
      state.userLoginInfo.companyCode = data.companyCode
      state.userLoginInfo.mobile = data.mobile
      state.userLoginInfo.isAdmin = data.isAdmin
      state.userLoginInfo.userPhoto = data.userPhoto
      state.userLoginInfo.companyName = data.companyName
      state.userLoginInfo.adminFlag = data.adminFlag
      state.userLoginInfo.sccCode = data.sccCode
      state.userLoginInfo.userId = data.userId
      state.userLoginInfo.cusCorpName = data.cusCorpName
      state.userLoginInfo.ciqCode = data.ciqCode
      state.userLoginInfo.tradeCode = data.tradeCode
    },
    // 用户切换公司信息变更
    userCompanyInfo: function (state, data) {
      state.userLoginInfo.companyType = data.companyType
      state.userLoginInfo.companyCode = data.companyCode
      state.userLoginInfo.isAdmin = data.isAdmin
      state.userLoginInfo.companyName = data.companyName
      state.userLoginInfo.sccCode = data.sccCode
      state.userLoginInfo.adminFlag = data.adminFlag
      state.userLoginInfo.cusCorpName = data.cusCorpName
      state.userLoginInfo.ciqCode = data.ciqCode
      state.userLoginInfo.tradeCode = data.tradeCode
    },
    // 初次进入系统后 变更状态
    isFirstChange: function (state, value) {
      state.isFirst = false
    },
    // 折叠操作
    collapse: function (state, value) {
      state.collapse = value
    },
    menuShow: function (state, value) {
      state.menuShow = value
    },
    // 获取已勾选看板
    getPanel: function (state, value) {
      state.controlPanelList = value
    },
    // 获取版本号
    versionInit: function (state, value) {
      state.paramVersion = value
    },
    // 是否断网
    changeNetwork: function (state, value) {
      state.netWork = value
    },
    // 获取用户类型
    getUserVipType: function (state, value) {
      state.userVipType = value
    },
    servicePaths: function (state, value) {
      state.servicePaths = value
    },
    changeServiceTip: function (state, value) {
      state.serviceTip = value
    },
    // 更换header菜单名
    toggleMenuName: function (state, value) {
      state.menuName = value
    }
  }
})
